import axios from 'axios';

const resolveBaseUrl = () => {
  const appBaseUrl =
    typeof import.meta.env.VITE_APP_BASE_URL === 'string'
      ? import.meta.env.VITE_APP_BASE_URL.trim()
      : '';
  if (appBaseUrl) {
    return appBaseUrl;
  }
  const apiBaseUrl =
    typeof import.meta.env.VITE_API_BASE_URL === 'string'
      ? import.meta.env.VITE_API_BASE_URL.trim()
      : '';
  if (apiBaseUrl) {
    try {
      const url = new URL(apiBaseUrl);
      return `${url.protocol}//${url.host}`;
    } catch {
      // ignore invalid URL
    }
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'http://localhost:8080';
};

const appBaseUrl = resolveBaseUrl();

const csrfClient = axios.create({
  baseURL: appBaseUrl,
  withCredentials: true,
});

let csrfToken: string | null = null;
let pendingFetch: Promise<string | null> | null = null;

async function fetchToken(): Promise<string | null> {
  try {
    const { data } = await csrfClient.get<{ csrfToken?: string }>('/csrf-token');
    csrfToken = data?.csrfToken ?? null;
    return csrfToken;
  } catch {
    csrfToken = null;
    return null;
  } finally {
    pendingFetch = null;
  }
}

export function getStoredCsrfToken(): string | null {
  return csrfToken;
}

export async function ensureCsrfToken(): Promise<string | null> {
  if (csrfToken) {
    return csrfToken;
  }
  if (!pendingFetch) {
    pendingFetch = fetchToken();
  }
  return pendingFetch;
}

export async function refreshCsrfToken(): Promise<string | null> {
  if (!pendingFetch) {
    pendingFetch = fetchToken();
  }
  return pendingFetch;
}

export function resetCsrfToken() {
  csrfToken = null;
  pendingFetch = null;
}
